module.exports = __webpack_public_path__ + "img/11.62458eac.png";